module.exports = __webpack_public_path__ + "static/Resin bonded brigde smile_before-dffb8993ce83a7f0236efcd600ed2ad7.jpg";